import type { LDFlagSet } from 'launchdarkly-react-client-sdk';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { getAppEnv, viteFFOverrides } from '@/constants/env';
import * as FeatureFlagNames from '@/constants/featureFlags';
import { Logger } from '@/utils/logger';

type UseLDFeatureFlagsType = {
  flags: LDFlagSet;
};

const logger = new Logger('useFeatureFlags');

const FF_OVERRIDE_LOCAL_STORAGE_KEY = 'FEATURE_FLAG_OVERRIDES';

const ENV_WITH_FF_OVERRIDES = ['test', 'development', 'qa', 'staging'];
const shouldApplyFFOverrides = ENV_WITH_FF_OVERRIDES.includes(getAppEnv());

sessionStorage.setItem('FEATURE_FLAG_KEYS', JSON.stringify(Object.values(FeatureFlagNames), null, 2));

export const useFeatureFlags = (): UseLDFeatureFlagsType => {
  const localStorageFFOverrides = JSON.parse(localStorage.getItem(FF_OVERRIDE_LOCAL_STORAGE_KEY) ?? '{}');
  const envFFOverrides = viteFFOverrides() ?? {};
  const overrides = { ...localStorageFFOverrides, ...envFFOverrides };
  shouldApplyFFOverrides && logger.info(`Overriding Feature Flags: ${JSON.stringify(overrides)}`);

  const LDflags = useFlags();

  const updatedFlags = {
    ...LDflags,
    ...(shouldApplyFFOverrides ? overrides : {})
  };

  return { flags: updatedFlags };
};
